import {
  FirestoreGenerationStatus,
  FirestoreProductActionsValue,
} from "reedy-data/models";
import { IProduct } from "reedy-data";

export function statusInProgress(status?: FirestoreGenerationStatus | null) {
  return (
    status &&
    [
      FirestoreGenerationStatus.REQUESTED,
      FirestoreGenerationStatus.GENERATING,
      FirestoreGenerationStatus.PROCESSING,
    ].includes(status)
  );
}

export function actionInProgress(
  ...actions: (FirestoreProductActionsValue | undefined | null)[]
) {
  return actions.some((s) => statusInProgress(s?.status));
}

export function actionErrored(
  ...actions: (FirestoreProductActionsValue | undefined | null)[]
) {
  return actions.some((s) => s?.status === FirestoreGenerationStatus.ERROR);
}

export function hasActiveActions(product?: IProduct | null): boolean {
  if (!product?.actions) {
    return false;
  }

  if (typeof product.actions.active === "boolean") {
    return product.actions.active;
  }

  // Backend may omit top-level active; fall back to per-category flags.
  return Boolean(
    product.actions.keywords?.active ||
      product.actions.descriptions?.active ||
      product.actions.thema?.active ||
      product.actions.manuscript?.active,
  );
}
